// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3BRtv","boxTitle":"Qualiphy_boxTitle__3ic1c","box":"Qualiphy_box__3VPaY","toggleWrap":"Qualiphy_toggleWrap__2VcO8"};